import { useState, type PropsWithChildren } from "react";

import { defaultWhitelabelBrand, whitelabelBrands, type WhitelabelBrand } from "@/configs/whitelabel";
import { WhitelabelBrandContext } from "@/providers/whitelabelBrandConfig";

const WhitelabelBrandProvider = ({ children }: PropsWithChildren) => {
  const [whitelabelBrand, setWhitelabelBrand] = useState<WhitelabelBrand>(defaultWhitelabelBrand);

  const currentWhitelabelBrand = whitelabelBrands.find((brand) => brand.urls.includes(location.hostname));
  if (currentWhitelabelBrand && currentWhitelabelBrand !== whitelabelBrand) setWhitelabelBrand(currentWhitelabelBrand);

  return <WhitelabelBrandContext value={whitelabelBrand}>{children}</WhitelabelBrandContext>;
};

export default WhitelabelBrandProvider;
